/*
 * Copyright (c) Dito Technologies
 */

import React from "react";
import Button from "ui/kit/buttons/Button";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import DeleteMusicPiece from "mutation/DeleteMusicPiece";
import {useNavigate} from "react-router-dom";
import {LIBRARY_PATH} from "constants/paths";

interface Props {
    pieceId: string;
}

const PieceSettingsDeleteItem: React.FC<Props> = ({pieceId}) => {

    const navigate = useNavigate();
    const [isDeleting, setIsDeleting] = React.useState(false);

    const onDelete = React.useCallback(async () => {
        setIsDeleting(true);
        await DeleteMusicPiece(pieceId);
        navigate(LIBRARY_PATH, {replace: true})
    }, [setIsDeleting, pieceId, navigate])

    return (
        <Button onClick={onDelete} title={"Delete"} icon={faTrash} disabled={isDeleting}/>
    )
}

export default PieceSettingsDeleteItem;